<template>
  <v-dialog
    :model-value="modelValue"
    max-width="640px"
    persistent
    data-testid="category-v2-dialog"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="bg-primary text-white">
        <v-icon class="mr-2">{{ isEditMode ? 'mdi-tag-edit-outline' : 'mdi-tag-plus-outline' }}</v-icon>
        {{ isEditMode ? 'แก้ไขหมวด (Category V2)' : 'เพิ่มหมวด (Category V2)' }}
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="formValid">
          <v-row>
            <v-col cols="12" md="7">
              <v-text-field
                data-testid="category-v2-code-input"
                v-model="form.categoryCode"
                label="Category code *"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-identifier"
                placeholder="เช่น INSURANCE"
                :rules="[rules.required, rules.max50]"
                :readonly="isEditMode"
                @update:model-value="form.categoryCode = String(form.categoryCode || '').toUpperCase()"
              />
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                data-testid="category-v2-sortOrder-input"
                v-model.number="form.sortOrder"
                label="Sort order *"
                type="number"
                min="0"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-sort-numeric-ascending"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>

          <v-text-field
            data-testid="category-v2-label-input"
            v-model="form.label"
            label="ชื่อหมวด"
            variant="outlined"
            density="comfortable"
            prepend-inner-icon="mdi-tag-outline"
            placeholder="เช่น ประกัน"
          />

          <v-switch
            data-testid="category-v2-active-switch"
            v-model="form.isActive"
            label="Active"
            color="success"
            inset
            hide-details
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn data-testid="category-v2-cancel-btn" variant="outlined" @click="close">
          <v-icon start>mdi-close</v-icon>
          Cancel
        </v-btn>
        <v-btn
          data-testid="category-v2-submit-btn"
          color="primary"
          variant="elevated"
          :disabled="!formValid"
          @click="submit"
        >
          <v-icon start>mdi-content-save</v-icon>
          {{ isEditMode ? 'Update' : 'Create' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TaxCategoryV2Dialog',
  props: {
    modelValue: { type: Boolean, default: false },
    initialData: { type: Object, default: null },
    /** default sort order for a new category (usually count + 1) */
    nextSortOrder: { type: Number, default: 1 },
  },
  emits: ['update:modelValue', 'submit'],
  data() {
    return {
      formValid: false,
      form: this.buildEmptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && String(v).trim() !== '') || 'Required',
        max50: (v) => String(v || '').length <= 50 || 'Maximum 50 characters',
      },
    };
  },
  computed: {
    isEditMode() {
      return Boolean(this.initialData && this.initialData.categoryID != null);
    },
  },
  watch: {
    modelValue(open) {
      if (open) this.resetForm();
    },
  },
  methods: {
    buildEmptyForm() {
      return {
        categoryID: null,
        categoryCode: '',
        label: '',
        sortOrder: this.nextSortOrder || 1,
        isActive: true,
      };
    },
    resetForm() {
      if (this.initialData) {
        const d = this.initialData;
        this.form = {
          categoryID: d.categoryID ?? null,
          categoryCode: d.categoryCode || '',
          label: d.label || '',
          sortOrder: d.sortOrder ?? 0,
          isActive: d.isActive ?? true,
        };
      } else {
        this.form = this.buildEmptyForm();
      }
      this.$nextTick(() => this.$refs.form?.resetValidation?.());
    },
    close() {
      this.$emit('update:modelValue', false);
    },
    async submit() {
      const result = await this.$refs.form?.validate?.();
      if (result && result.valid === false) return;
      this.$emit('submit', {
        categoryID: this.form.categoryID,
        categoryCode: String(this.form.categoryCode || '').trim().toUpperCase(),
        label: this.form.label || '',
        sortOrder: Number(this.form.sortOrder) || 0,
        isActive: Boolean(this.form.isActive),
      });
    },
  },
};
</script>
